/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveReentrancyCheck,
  ICurveReentrancyCheckInterface,
} from "../ICurveReentrancyCheck";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_gasLimit",
        type: "uint128",
      },
      {
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "_nCoins",
        type: "uint8",
      },
    ],
    name: "setReentrancyVerificationConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ICurveReentrancyCheck__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveReentrancyCheckInterface {
    return new utils.Interface(_abi) as ICurveReentrancyCheckInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveReentrancyCheck {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveReentrancyCheck;
  }
}
